module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\" style=\"enable-background:new 0 0 64 64;\" xml:space=\"preserve\"><path d=\"M56.5,19c-0.5-0.5-1.3-0.5-1.6,0L31.9,42.4L9.1,19.2c-0.5-0.5-1.2-0.5-1.6,0c-0.5,0.5-0.5,1.2,0,1.6l23.6,24.1 c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.2,0.9-0.4l23.8-24.3C57,20.3,57,19.5,56.5,19z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./frontend/images/icons/chevron-down.svg
// module id = 396
// module chunks = 0